
import React from 'react';
import SideBar from '../Utility/SideNav';
import TopNav from '../Utility/TopNav';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import CompletedUserStories from './completedUserStories';
import CompletedSubTasks from './completedSubTasks';
import { useWebProperties } from '../../Common/webProperties';


export default function MainTaskSubTaskTabs() {
    const { MAINTASKS, SUBTASK, WORKFLOW_ENABLE } = useWebProperties();
    return (
        <div className="container-scroller">
            <TopNav />
            <div className="container-fluid page-body-wrapper">
                <SideBar />
                <div className="main-panel">
                    <div className="mt-2">
                        <Tabs
                            defaultActiveKey="sprint"
                            id="uncontrolled-tab-example"
                            className="mb-3"
                        >
                            <Tab eventKey="sprint" title={MAINTASKS}>
                                <CompletedUserStories />
                            </Tab>
                            {
                                WORKFLOW_ENABLE === '1' ?
                                    <Tab eventKey="profile" title={SUBTASK}>
                                        <CompletedSubTasks />
                                    </Tab>
                                    :
                                    null
                            }
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>

    )
}